import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { RadioButton } from 'react-toolbox/lib/radio'
import CSSModules from 'helpers/CSSModulesUtil'

import styles from './styles.scss'

const FulcrumRadioButton = props => {
  const {
    checked,
    className,
    disabled,
    label,
    name,
    onBlur,
    onChange,
    onFocus,
    value
  } = props

  return (
    <RadioButton
      theme={styles}
      checked={checked}
      className={className}
      disabled={disabled}
      label={label}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      value={value}
    />
  )
}

export default CSSModules(styles, FulcrumRadioButton)
